// import { reject, resolve } from "core-js/fn/promise"
import * as api from "../api/index"
// 图片数据
export default {
    namespaced: true,
    state: {
        hotList: new Map(), // 存储首页推荐
        categoryList: new Map(), // 存储首页分类列表
        categoryDataList: new Map(), // 存储首页图片数据
        downloadList: [] // 储存下载组件下载列表
    },
    getters: {

    },
    mutations: {
        // 存储首页推荐
        setHotList (state, payload) {
            state.hotList.set(payload.key, payload.value)
        },
        // 存储分类列表
        setCategory (state, payload) {
            state.categoryList.set(payload.key, payload.value)
        },
        // 存储首页图片数据
        setCategoryDataList (state, payload) {
            state.categoryDataList.set(payload.key, payload.value)
        },
        setDownloadList (state, listItem) {
            state.downloadList.push(listItem)
        }
    },
    actions: {
        // 获取首页推荐数据
        getHotData ({ commit, state }, payload) {
            if (state.hotList.get(payload.type)) {
                return new Promise((resolve, reject) => {
                    resolve(state.hotList.get(payload.type))
                })
            } else {
                return new Promise((resolve, reject) => {
                    api.getHotModule(payload, res => {
                        if (res.status === 'success') {
                            commit('setHotList', {
                                key: payload.type,
                                value: res.result
                            })
                            resolve(state.hotList.get(payload.type))
                        }
                    })
                })
            }
        },
        // 获取分类列表
        getCategory ({ commit, state }, payload) {
            if (state.categoryList.get(payload.type)) {
                return new Promise((resolve, reject) => {
                    resolve(state.categoryList.get(payload.type))
                })
            } else {
                return new Promise((resolve, reject) => {
                    api.getCategoryByType({ type: payload.type }, res => {
                        if (res.status === 'success') {
                            commit('setCategory', {
                                key: payload.type,
                                value: res.result.data
                            })
                            resolve(state.categoryList.get(payload.type))
                        }
                    })
                })
            }
        },
        // 获取首页图片数据
        getCategoryData ({ commit, state }, payload) {
            if (state.categoryDataList.get(payload.menuId)) {
                return new Promise((resolve, reject) => {
                    resolve(state.categoryDataList.get(payload.menuId))
                })
            } else {
                return new Promise((resolve, reject) => {
                    api.getList({
                        offset: 0,
                        length: 20,
                        type: payload.type,
                        menus_id: payload.menuId
                    }, res => {
                        commit('setCategoryDataList', {
                            key: payload.menuId,
                            value: res.result.data
                        })
                        resolve(state.categoryDataList.get(payload.menuId))
                    })
                })

            }

        },
    },
}